import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { CustomLabelSwitchProps } from "./type";
import CustomSwitch from "./Switch";
import { Icons } from "@/assets/images";
import CustomToolTip from "./ToolTip";

const CustomLabelSwitch = (
  props: CustomLabelSwitchProps,
): React.ReactElement => {
  const {
    className,
    info,
    readOnly,
    fieldName,
    labelName,
    triggerContent,
    fieldCss,
    side,
    wrapperCss,
    checked,
    onCheckedChange,
  } = props;

  return (
    <div className={`w-full custom-label-switch ${className}`}>
      {labelName && <Label className="mb-1.5">{labelName}</Label>}
      <div
        className={`field-wrapper relative w-full flex items-center justify-between gap-2.5 border border-border rounded-10 py-[9px] px-3.5 ${readOnly && "field-block"} ${wrapperCss}`}
      >
        <div className={`flex items-center gap-1.5 `}>
          <p className={`tracking-wide ${fieldCss}`}>{fieldName}</p>
          {info && (
            <CustomToolTip
              side={side ? side : "bottom"}
              triggerChild={
                <Button variant="info" className="min-w-4 pointer-events-auto" type="button">
                  <img src={Icons.infoIcon} alt="info-icon" />
                </Button>
              }
              triggerContent={triggerContent}
              className="text-sm"
            />
          )}
        </div>
        <CustomSwitch
          checked={checked}
          onCheckedChange={onCheckedChange}
          parentBlockCss="!gap-0"
        />
      </div>
    </div>
  );
};

export default CustomLabelSwitch;
